<template>
    <div>
        <div id="signature-pad" class="signature-pad">
            <div class="signature-pad--toolbar">
                <div class="signature-pad--actions">
                    <div>
                    </div>
                </div>
            </div>
            <div class="signature-pad--body">
                <div class="signature-pad--mark unselectable-text" style="color:black;">Sign here with your finger, trackpad, or mouse.</div>
                <canvas id="signature-pad--canvas"></canvas>

                <div class="signature-pad--line"></div>
                <div class="signature-pad--footer" style=" position: absolute; bottom: 0px; width: 100%; z-index:1000;">
                    <div class="signature-pad--actions">
                        <div style="display:flex; justify-content:center;">
                            <button type="button" class="btn btn-danger btn-sm" data-action="clear" @click="onPadClear">
                                <svg class="bi bi-trash-fill" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0v-7z" />
                                </svg>Clear
                            </button>

                            <button type="button" class="btn btn-success btn-sm" data-action="agree" @click="onPadAgree" style="display: none;">
                                <svg class="bi bi-check2" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z" />
                                </svg>
                                {{okButton}}
                            </button>

                        </div>
                    </div>
                </div>
            </div>
         
           
           
        </div>
    </div>
</template>

<script>
    import SignaturePad from 'signature_pad'

    export default {
        data() {
            return {
                canvas: null,
                signaturePad: null
            }
        },
        mounted() {
            this.signature_init();
        },
        props: {
            okButton: {
                default: 'Agree',
                type: String
            }
        },
        methods: {
            signature_init() {
                //console.log("======> signature_init");
                if (null === this.signaturePad) {
                    this.canvas = document.getElementById("signature-pad--canvas");
                    this.signaturePad = new SignaturePad(this.canvas, {
                        backgroundColor: 'rgba(255, 255, 255, 0.0)',
                        penColor: 'rgb(0, 0, 0)',
                        minWidth: 0.01,
                        maxWidth: 2.5,
                        dotSize: 2
                    });
                }

                /*
                this.signaturePad.onClear = () => {
                    console.log("========== Signature Pad On Clear =========");
                }

                this.signaturePad.onCancel = () => {
                    console.log("========== Signature Pad On Cancel =========");
                }

                this.signaturePad.onAgree = (PNGData, info) => {
                    console.log(`========== Signature Pad On Agree =========`, info);
                    console.log(`========== PNG Data =========`, PNGData);
                }
                */

                let _this = this;

                window.onresize = this.resizeCanvas;
                setTimeout(function () { _this.refresh();}, 50);
                
            },

            refresh() {
                // Do something preload data
                this.resizeCanvas();
                this.preload();
            },

            preload() {

            },

            resizeCanvas() {
                // console.log("========> Resize Canvers");
                var ratio = Math.max(window.devicePixelRatio || 1, 1);
               
                this.canvas.width = this.canvas.offsetWidth * ratio;
                this.canvas.height = this.canvas.offsetHeight * ratio;
                if (this.canvas.width > 0 && this.canvas.offsetHeight == 0)
                    this.canvas.height = 150;
             
                //console.log("canvas size:", this.canvas.width + ", " + this.canvas.height);
                this.canvas.getContext("2d").scale(ratio, ratio);
                this.signaturePad.clear();
            },

            download(dataURL, filename) {
                //console.log("Download Data ===>", dataURL);
                if (navigator.userAgent.indexOf("Safari") > -1 && navigator.userAgent.indexOf("Chrome") === -1) {
                    window.open(dataURL);
                } else {
                    var blob = this.dataURLToBlob(dataURL);
                    var url = window.URL.createObjectURL(blob);

                    var a = document.createElement("a");
                    a.style = "display: none";
                    a.href = url;
                    a.download = filename;

                    document.body.appendChild(a);
                    a.click();

                    window.URL.revokeObjectURL(url);
                }
            },

            dataURLToBlob(dataURL) {
                var parts = dataURL.split(';base64,');
                var contentType = parts[0].split(":")[1];
                var raw = window.atob(parts[1]);
                var rawLength = raw.length;
                var uInt8Array = new Uint8Array(rawLength);
                for (var i = 0; i < rawLength; ++i) {
                    uInt8Array[i] = raw.charCodeAt(i);
                }
                return new Blob([uInt8Array], { type: contentType });
            },

            dataURLToFileObject(dataURL) {
                var parts = dataURL.split(';base64,');
                var contentType = parts[0].split(":")[1];
                var raw = window.atob(parts[1]);
                var rawLength = raw.length;
                //console.log(`==== Signature Pad Raw Image Size: ${rawLength} ====`);
                var uInt8Array = new Uint8Array(rawLength);
                for (var i = 0; i < rawLength; ++i) {
                    uInt8Array[i] = raw.charCodeAt(i);
                }
                //console.log(`==== Signature Pad Buff Image Size: ${uInt8Array.length} ====`);
                var b = new Blob([uInt8Array], { type: contentType });
                var file = new File([b], "signature.png", { type: contentType, lastModified: new Date().getTime() });
                return file;
            },

            renderTestLink() {
                var imageFile = this.dataURLToFileObject(this.signaturePad.toDataURL());
                var fr = new FileReader();
                fr.onload = () => {
                    document.body.innerHTML += `
                           <a href="${URL.createObjectURL(imageFile)}" download="${imageFile.name}">download</a>
                            <p>file type: ${imageFile.type}</p>
                            <p>file last modified: ${new Date(imageFile.lastModified)}</p>
                          `;
                }
                fr.readAsArrayBuffer(imageFile);
            },

            onPadSetColor(v) {
                this.signaturePad.penColor = v;
                this.signaturePad.clear();
            },

            onPadClear() {
                this.signaturePad.clear();
                if (this.signaturePad.onClear) {
                    this.signaturePad.onClear();
                }
            },

            onPadCancel() {
                if (this.signaturePad.onCancel) {
                    this.signaturePad.onCancel();
                }

                this.$emit('cancel-event');
            },

            onPadAgree() {
                if (this.signaturePad.isEmpty()) {
                    //this.$alert("Please provide a signature first.");
                    this.$emit('agree-event', null);
                } else {
                    //SVG
                    //var dataURL = signaturePad.toDataURL('image/svg+xml');

                    //PNG
                    var dataURL = this.signaturePad.toDataURL();
                    if (this.signaturePad.onAgree) {
                        //var r = Number.parseFloat((this.canvas.width / this.canvas.height).toFixed(3));
                        //this.signaturePad.onAgree(dataURL, { width: this.canvas.width, height: this.canvas.height, rate: r });
                    }
                    this.$emit('agree-event', this.dataURLToFileObject(dataURL));
                }
            }
        }
    }
</script>

<style scoped>
    .btn-sm{
        width: 100px ;
        height:fit-content;
        font-size: 14px;
        line-height:36px;
    }
    .unselectable-text {
        -webkit-user-select: none; /* Safari */
        -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
        user-select: none; /* Non-prefixed version, currently supported by Chrome, Opera, and Edge */
    }

    .signature-pad *::before,
    .signature-pad *::after {
        box-sizing: border-box;
    }

    .signature-pad {
        position: relative;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
        font-size: 10px;
        width: 100%;
        
        height: 280px;
       
        border-radius: 8px;
        border: 1px solid #c0c0c0;
        padding: 0px;
       
        margin: auto;
        overflow: hidden;
    }

        .signature-pad--body {
            position: relative;
            -webkit-box-flex: 1;
            -ms-flex: 1;
            flex: 1;
            border: 1px solid #ccc;
            border-radius: 5px;
            margin:16px;
            background-color: #ffffff;
            min-height:160px;
        }

        .signature-pad--body
        canvas {
           
            width: 100%;
            height: 100px;
            background-color: transparent;
           
            margin: 0px;
            z-index: 1;
        }


    .signature-pad--line {
        margin: auto;
        width: 80%;
        background-color: transparent;
        height: 2px;
        border-bottom: 1px dashed #a0a0a0;
        z-index: 0;
    }

    .signature-pad--mark {
        
         margin-top:8px;
        bottom: 30%;
        width: 100%;
        color: #c0c0c0;
        font-size: 14px;
        font-weight: lighter;
        background-color: transparent;
        z-index: 0;
        text-align: center;
    }

    .signature-pad--toolbar {
        color: #606060;
        text-align: center;
        font-size: 1.5em;
        font-weight: normal;
        margin: 0px;
        padding: 0px 12px 8px 12px;
       
    }

    .signature-pad--footer {
        color: #606060;
        text-align: center;
        font-size: 1.5em;
        font-weight: normal;
        margin: 0px;
        padding: 8px;
       
    }

    .signature-pad--actions {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        margin-top: 8px;
    }


    .signature-pad--footer .signature-pad--actions {
        display: block;
        text-align: center;
    }

        .signature-pad--footer .signature-pad--actions button {
           margin:8px;
        }

    .signature-pad--actions .pen {
        width: 24px;
        height: 24px;
        display: inline-block;
        margin: 0px;
        padding: 0px;
    }

    .signature-pad--actions button svg {
        width: 1.5em;
        height: 1.5em;
        vertical-align: middle;
    }

   

    @media (max-width: 600px) {
       
        .signature-pad--body{margin: 4px; }
    }

    @media (min-width:576px) {
        .modal-dialog {
            max-width: 80%;
            margin: 1.75rem auto
        }
        
    }
</style>